import { useField } from 'formik'
import React from 'react'

import { Checkbox } from 'app/components/ui/form/Checkbox'
import { FormFeedback } from 'app/components/ui/form/FormFeedback'
import { addErrorDataAttribute } from './utils'

interface Props {
  name: string
  idPrefix?: string
  reverseBehaviour?: boolean
}

export const SmartCheckbox: React.FC<Props> = ({
  name,
  children,
  idPrefix,
  reverseBehaviour,
}) => {
  const [field, meta, helper] = useField(name)
  const isInvalid = Boolean(meta.error && meta.touched)

  const valueForChecked = reverseBehaviour ? !field.value : field.value

  return (
    <div>
      <Checkbox
        idPrefix={idPrefix}
        name={name}
        isChecked={valueForChecked}
        onChange={() => {
          helper.setValue(!field.value)
        }}
        {...addErrorDataAttribute(meta)}
      >
        {children}
      </Checkbox>
      {isInvalid ? (
        <FormFeedback variant='error'>{meta.error}</FormFeedback>
      ) : null}
    </div>
  )
}
